var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenobianco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 16 17",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7.40008 8.06836h-7.40008v1.19996h7.40008 1.19984 7.40008v-1.19996h-7.40008z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    opacity: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenobianco);
export default __webpack_public_path__ + "static/media/menobianco.7efc1f4ae00cc8d3ab7e18116e55b1b1.svg";
export { ForwardRef as ReactComponent };